import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

// Demonstrate the entire product promise with one understandable family ledger.
export function LedgerDemo() {
  return (
    <div className="relative mx-auto w-full max-w-lg lg:mr-0">
      <div className="bg-secondary absolute -top-4 -right-3 -bottom-4 left-5 -rotate-2 rounded-2xl" />
      <div className="panel-shadow bg-card relative overflow-hidden rounded-2xl border">
        <div className="border-b px-5 py-5 sm:px-7">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="bg-accent ring-background size-10 rounded-full ring-4" />
              <div>
                <p className="font-medium">Maya&apos;s money</p>
                <p className="text-muted-foreground text-xs">Virtual ledger</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-muted-foreground text-xs">Balance</p>
              <p className="money-numbers font-serif text-2xl font-semibold">
                $18.50
              </p>
            </div>
          </div>
        </div>

        <div className="ledger-paper px-5 py-3 sm:px-7">
          <DemoEntry
            amount="+$10.00"
            description="Weekly allowance"
            icon={ArrowDownLeft}
            tone="income"
          />
          <DemoEntry
            amount="+$15.00"
            description="Birthday gift"
            icon={ArrowDownLeft}
            tone="income"
          />
          <DemoEntry
            amount="−$6.50"
            description="New book"
            icon={ArrowUpRight}
            tone="spend"
          />
        </div>

        <div className="bg-muted/60 flex items-center justify-between border-t px-5 py-4 text-sm sm:px-7">
          <span className="text-muted-foreground">Recorded together</span>
          <span className="font-medium">No bank connected</span>
        </div>
      </div>
    </div>
  );
}

interface DemoEntryProps {
  amount: string;
  description: string;
  icon: typeof ArrowDownLeft;
  tone: "income" | "spend";
}

// Render one plain-language example entry with meaning beyond color alone.
function DemoEntry({ amount, description, icon: Icon, tone }: DemoEntryProps) {
  return (
    <div className="flex h-10 items-center gap-3">
      <Icon
        className={
          tone === "income" ? "text-income size-4" : "text-spend size-4"
        }
      />
      <span className="min-w-0 flex-1 truncate text-sm">{description}</span>
      <span
        className={`money-numbers text-sm font-semibold ${
          tone === "income" ? "text-income" : "text-foreground"
        }`}
      >
        {amount}
      </span>
    </div>
  );
}
